
// SVG Icon: close-light
export default { id: "terriajs-close-light" };
export const id = "terriajs-close-light";
export const name = "close-light";
